import { useState } from "react";
import { Share2, Link2, MessageSquare } from "lucide-react";
import { toast } from "sonner";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-current" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
);

export default function SharePick({ text }) {
  const [open, setOpen] = useState(false);
  const url = window.location.href;
  const full = `${text} — Sportsbook Smasher`;
  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "Sportsbook Smasher Pick", text: full, url });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    setOpen(!open);
  };
  const copy = async () => {
    await navigator.clipboard?.writeText(`${full} ${url}`);
    toast.success("Pick copied — paste it into your Instagram story or post");
  };
  const btn = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-white/5 text-slate-200 hover:text-smasher-gold hover:bg-white/10 transition-colors";
  return (
    <div className="mt-3" data-testid="share-pick">
      <button onClick={share} className="btn-gold px-4 py-2 rounded-lg text-xs font-black inline-flex items-center gap-2" data-testid="share-pick-button">
        <Share2 className="w-3.5 h-3.5" /> SHARE THIS PICK
      </button>
      {open && (
        <div className="flex flex-wrap gap-2 mt-2" data-testid="share-pick-options">
          <a className={btn} target="_blank" rel="noreferrer" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(full)}&url=${encodeURIComponent(url)}`} data-testid="share-x"><XIcon /> Post on X</a>
          <a className={btn} href={`sms:?&body=${encodeURIComponent(`${full} ${url}`)}`} data-testid="share-sms"><MessageSquare className="w-3.5 h-3.5" /> Text</a>
          <button className={btn} onClick={copy} data-testid="share-instagram"><Link2 className="w-3.5 h-3.5" /> Copy for Instagram</button>
        </div>
      )}
    </div>
  );
}
